import { useIsMobileScreen } from '@shared/utils/media/useMediaScreens';
import React from 'react';
import { Box, Flex, TextV2 } from '@withjoy/joykit';
import { StationeryTemplateCategoryEnum } from '@graphql/generated';
import { Link, useTranslation } from '@shared/core';
import { useCardsRouterContext } from '@apps/card/Card.routes';
import { useExitWithoutCreatingDraftHandler } from '../useExitWithoutCreatingDraftHandler';
import { ChevronBack } from '@withjoy/joykit/icons';
import { Skeleton } from '@shared/components/Skeleton';
import { useStationeryTemplateCategoryTranslations } from '@apps/card/hooks/useStationeryTemplateCategoryTranslations';

const Slash = () => <Box as="span">/</Box>;

const DesktopContainer: React.FC = ({ children }) => {
  return (
    <Flex
      typographyVariant="hed2"
      __css={{
        [' > *']: {
          paddingX: 4,
          paddingY: 1,
        },
      }}
    >
      {children}
    </Flex>
  );
};

export const Breadcrumbs = ({ designName, templateCategory }: { designName: string; templateCategory: StationeryTemplateCategoryEnum }) => {
  const { tq } = useTranslation('stationery');
  const isMobile = useIsMobileScreen();
  const { getShopPath } = useCardsRouterContext();

  const onClickRoot = useExitWithoutCreatingDraftHandler('breadcrumbsRootLink');
  const onClickCategory = useExitWithoutCreatingDraftHandler('breadcrumbsCategoryLink');

  const getCategoryName = useStationeryTemplateCategoryTranslations('designsGalleryPdpBreadcrumbCategory');
  const categoryName = getCategoryName(templateCategory);

  return isMobile ? (
    <Flex
      as={Link}
      display="inline-flex"
      alignItems="center"
      to={getShopPath('wedding', templateCategory)}
      onClick={onClickCategory}
      columnGap={3}
    >
      <ChevronBack size={16} />
      <TextV2 typographyVariant="hed2">{categoryName}</TextV2>
    </Flex>
  ) : (
    <DesktopContainer>
      <Box
        as={Link}
        to={getShopPath('wedding')}
        onClick={onClickRoot}
      >
        {tq`Cards`}
      </Box>
      <Slash />
      <Box
        as={Link}
        to={getShopPath('wedding', templateCategory)}
        onClick={onClickCategory}
      >
        {categoryName}
      </Box>
      <Slash />
      <Box
        as="span"
        color="mono10"
        cursor="default"
      >
        {designName}
      </Box>
    </DesktopContainer>
  );
};

const BreeadcrumbsSkeleton = () => {
  const isMobile = useIsMobileScreen();

  return isMobile ? (
    <Flex
      display="inline-flex"
      alignItems="center"
      columnGap={3}
    >
      <Skeleton />
      <Skeleton />
    </Flex>
  ) : (
    <DesktopContainer>
      <Skeleton width={60} />
      <Slash />
      <Skeleton width={120} />
      <Slash />
      <Skeleton width={200} />
    </DesktopContainer>
  );
};

Breadcrumbs.Skeleton = BreeadcrumbsSkeleton;
